import {useEffect, useState} from 'react';
import ReportItem from './ReportItem';
import Text from '../../common/component/Text';
import {ReportType} from '../type';

interface IProps {
  type: ReportType;
  isSelected: boolean;
  content: string;
  commentId: number;
  onChange: (type: ReportType) => void;
}

export default function ExpandableItem({
  type,
  isSelected,
  content,
  commentId,
  onChange,
}: IProps) {
  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    setIsExpand(prev => prev || isSelected);
  }, [isSelected]);

  return (
    <div>
      <ReportItem
        type={type}
        isSelected={isSelected}
        commentId={commentId}
        className={isExpand ? 'mb-14' : undefined}
        onChange={onChange}
      />
      {isExpand && (
        <Text className={cn('ml-28 mb-15 pr-3 s12-regular-grey08')}>
          {content}
        </Text>
      )}
    </div>
  );
}
